import { List } from 'immutable'
import { Record } from '../transit'
import Attendance from './Attendance'
import Attender from './Attender'
import * as actions from './actions'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  new: null,
  attenders: new List(),
  all: new List(),
  current: new Attendance(),
  meta: new ListMeta(),
}, 'attendances')

const attendancesReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.LOAD_ATTENDANCES_SUCCESS: {
      const attendances = List(action.payload.data.map(json => new Attendance(json)))
      return state.set('all', attendances).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.LOAD_ATTENDANCE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      const attenders = new List(action.payload.data.drivers.map((d) => {
        let attender = new Attender(d.driver)
        attender = attender.set('sign', d.signImagePath)
        return attender
      }))
      return state.set('current', attendance).set('attenders', attenders)
    }
    case actions.ADD_ATTENDANCE: {
      const attendance = Attendance(action.payload.attendance)
      return state.set('new', attendance)
    }
    case actions.ADD_ATTENDER: {
      const attender = Attender(action.payload.attender)
      return state.set('attenders', state.attenders.push(attender))
    }
    case actions.UPDATE_ATTENDER: {
      const attender = Attender(action.payload.attender)
      const index = action.payload.index
      return state.set('attenders', state.attenders.set(index, attender))
    }
    case actions.DELETE_ATTENDER: {
      const index = action.payload.index
      return state.set('attenders', state.attenders.delete(index))
    }
    case actions.ATTENDANCE_HEADER_LOAD_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_HEADER_CREATE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_HEADER_UPDATE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_HEADER_STATE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_HEADER_DELETE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_HEADER_CLEAR: {
        return state.set('new', null).set('current', new Attendance())
    }
    case actions.ATTENDANCE_PDF_REMOVE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_FEEDBACKS_PDF_REMOVE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_PDF_NEW_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_PDF_SAVE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_FEEDBACKS_PDF_SAVE_SUCCESS: {
      const attendance = new Attendance(action.payload.data)
      return state.set('current', attendance)
    }
    case actions.ATTENDANCE_UPDATE_SUCCESS: {
      const pdf = action.payload.data.pdf
      const attendance = state.get('current').set('pdf', pdf)
      return state.set('current', attendance)
    }
    case actions.CLEAR_ATTENDENCE: {
      return state.set('new', null).set('attenders', new List())
    }
    case actions.CLEAR_ATTENDENCES: {
      return new State()
    }
    default:
      return state
  }
}

export default attendancesReducer



// WEBPACK FOOTER //
// ./src/common/attendances/reducer.js